var cookieBanner = {

    elements: {},
    bannerClosedCookieName: 'cookie-banner-closed',

    init: function() {
        if(!this.getElements()) {
            return false;
        }

        if(this.bannerClosed()) {
            this.remove();
            return;
        }

        this.setEvents();
        this.show();
    },

    getElements: function() {
        this.elements.cookieBanner = jQuery('.cookie-banner');
        if(!this.elements.cookieBanner.length) {
            return false;
        }

        this.elements.closeButton = jQuery('.cookie-banner__close-button');
        if(!this.elements.closeButton.length) {
            return false;
        }

        return true;
    },

    bannerClosed: function() {
        return typeof Cookies.get(this.bannerClosedCookieName) !== 'undefined';
    },

    remove: function() {
        this.elements.cookieBanner.remove();
    },

    setEvents: function() {
        var _self = this;

        this.elements.closeButton.on('click', function() {
            _self.close();
        });
    },

    show: function() {
        this.elements.cookieBanner.removeClass('cookie-banner--disabled');
    },

    close: function() {
        this.remove();
        Cookies.set(this.bannerClosedCookieName, true);
    }

};

jQuery(document).ready(function() {
    cookieBanner.init();
});
